'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { WELLO_IMAGE_PREFIX_URL } from '@/constants';
const ICONS = [`${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/gift-box.png?w=160&q=100&f=auto`, `${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/money.png?w=160&q=100&f=auto`];
export const PopcornEffect = () => {
  const $ = _c(3);
  const containerRef = useRef(null);
  const timeoutRef = useRef(null);
  const iconIndexRef = useRef(0);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const createSingleFirework = (t2, slotX) => {
        const delay = t2 === undefined ? 0 : t2;
        if (!containerRef.current) {
          return;
        }
        const container = containerRef.current;
        const icon = ICONS[iconIndexRef.current];
        iconIndexRef.current = (iconIndexRef.current + 1) % ICONS.length;
        const startX = slotX + (Math.random() - 0.5) * 30;
        const randomDriftX = (Math.random() * 240 - 120) * (Math.random() * 0.5 + 0.8);
        const maxRotate = (Math.random() * 15 + 10) * (Math.random() > 0.5 ? 1 : -1);
        const img = document.createElement("img");
        img.src = icon;
        img.alt = "";
        img.style.cssText = `
        position: absolute;
        bottom: 0;
        left: ${startX}px;
        width: 80px;
        height: 80px;
        object-fit: contain;
        pointer-events: none;
        will-change: transform, opacity;
        opacity: 0;
      `;
        container.appendChild(img);
        setTimeout(() => {
          const startTime = performance.now();
          const animate = currentTime => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / 2500, 1);
            if (progress >= 1) {
              img.remove();
              return;
            }
            const t = progress;
            const parabola = -4.395604395604396 * (t - 0.35) * (t - 0.35) + 1;
            const translateY = -parabola * 170;
            const easeOutProgress = 1 - Math.pow(1 - progress, 2);
            const translateX = randomDriftX * easeOutProgress;
            const scale = 0.6 + parabola * 0.5;
            const rotate = maxRotate * progress;
            let opacity;
            if (progress < 0.08) {
              opacity = progress * 12.5;
            } else {
              if (progress > 0.75) {
                opacity = (1 - progress) * 4;
              } else {
                opacity = 1;
              }
            }
            img.style.transform = `translate(${translateX}px, ${translateY}px) scale(${scale}) rotate(${rotate}deg)`;
            img.style.opacity = Math.max(0, Math.min(1, opacity)).toString();
            requestAnimationFrame(animate);
          };
          requestAnimationFrame(animate);
        }, delay);
      };
      const createFireworkBurst = () => {
        const count = Math.floor(Math.random() * 3) + 5;
        const slots = [];
        const slotWidth = 280 / count;
        for (let index = 0; index < count; index++) {
          slots.push(40 + slotWidth * index + slotWidth / 2);
        }
        slots.sort(_temp);
        for (let index_0 = 0; index_0 < count; index_0++) {
          createSingleFirework(index_0 * (Math.random() * 100 + 50), slots[index_0]);
        }
        timeoutRef.current = setTimeout(createFireworkBurst, Math.random() * 1500 + 1500);
      };
      const initialTimeout = setTimeout(createFireworkBurst, 500);
      return () => {
        clearTimeout(initialTimeout);
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div ref={containerRef} className="pointer-events-none absolute -inset-x-100 -bottom-20 -top-300" style={{
      clipPath: "inset(0 -100px 40px -100px)"
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp() {
  return Math.random() - 0.5;
}